import { EntitySortUtil } from '@core/utils/entity-sort.util';
import { ChangeRequest } from '@shared/change-request/change-request';

export class ChangeRequestSort {
  static byEntity = (a: ChangeRequest, b: ChangeRequest): number => {
    let result = EntitySortUtil.byStringValue(a.entityName, b.entityName);
    if (result === 0) {
      result = EntitySortUtil.byStringValue(a.entityUuid, b.entityUuid);
    }
    if (result === 0) {
      result = EntitySortUtil.byStringValue(a.entityField, b.entityField);
    }

    return result;
  };

  static byOriginalValue = (a: ChangeRequest, b: ChangeRequest): number => {
    if (typeof a.originalValue === 'number' && typeof b.originalValue === 'number') {
      return a.originalValue - b.originalValue;
    } else {
      return EntitySortUtil.byStringValue(`${a.originalValue}`, `${b.originalValue}`);
    }
  };

  static byRequestedValue = (a: ChangeRequest, b: ChangeRequest): number => {
    if (typeof a.requestedValue === 'number' && typeof b.requestedValue === 'number') {
      return a.requestedValue - b.requestedValue;
    } else {
      return EntitySortUtil.byStringValue(`${a.requestedValue}`, `${b.requestedValue}`);
    }
  };
}
